import React from 'react';
import { Hero } from './components/sections/Hero';
import { PainPoints } from './components/sections/PainPoints';
import { Tomos } from './components/sections/Tomos';
import { Bonuses } from './components/sections/Bonuses';
import { Pricing } from './components/sections/Pricing';
import { EliteProtocol } from './components/sections/EliteProtocol';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { PurchaseNotifier } from './components/PurchaseNotifier';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="w-full bg-ink text-ice" data-id="element-0" data-mp="2wiyvintcfl9k">
      <Hero data-id="element-1" data-mp="2wi5nljineppu" />
      <main data-id="element-2" data-mp="28ufmg62gz4gf">
        <PainPoints data-id="element-3" data-mp="28tw5arkn8k3g" />
        <Tomos data-id="element-4" data-mp="28te3lff7pdo5" />
        <Bonuses data-id="element-5" data-mp="28suw6sn6u7od" />
        <Pricing data-id="element-6" data-mp="28sb9yzqi8x4j" />
        <EliteProtocol data-id="element-7" data-mp="23vchelmhoy8g" />
        <Guarantee data-id="element-8" data-mp="23w4fq47h1a2f" />
        <Faq data-id="element-9" data-mp="23ujk0b9f7l2z" />
        <FinalCTA data-id="element-10" data-mp="23ut97wmn5o7m" />
      </main>
      <Footer data-id="element-11" data-mp="3ijxpqrsp22kf" />
      <PurchaseNotifier data-id="element-12" data-mp="3ik7k0rkruvvx" />
      <StickyCTA data-id="element-13" data-mp="3iiwfgpji5k3r" />
    </div>;
}